import {smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";

window.closeImagePopupModal = (event, value = false) => {
  updateMeta(true);
  if (value === true) {
    if (!event.target.classList.contains('block-wrapper') && !event.target.classList.contains('inner-children')) {
      return;
    }
  }
  const modal = $('.js-timeline-image-modal')
  modal.removeClass('modal-active');
  modal.find('.js-popup-image').attr('src', "").attr('alt', "");
  modal.find('.js-image-popup-modal-text').text("");
  $('body').removeClass('overflow-hidden');
  $('html').removeClass('overflow-hidden');
  smoothScrollPlay();
  window.finishTimelineGridAnimation();
  updateTimelineImageParameter(null);

};

window.openImagePopupModal = (e, slug, meta_title = '', meta_description = '') => {
  const modal = $('.js-timeline-image-modal')
  const information = e.querySelector('.js-image-popup-info');
  if (information) {
    const text = information.querySelector('.js-image-popup-text').innerText;
    const title = information.querySelector('.js-image-popup-title').innerText;
    const imageSrc = information.querySelector('.js-image-popup-image').innerText;
    modal.find('.js-popup-image').attr('src', imageSrc).attr('alt', title);
    modal.find('.js-image-popup-modal-text').text(text);
  }
  updateMeta(false, meta_title, meta_description, false);
  modal.addClass('modal-active');
  $("#timeline-image-modal-content").scrollTop(0);
  $('body').addClass('overflow-hidden');
  $('html').addClass('overflow-hidden');
  smoothScrollPause();
  window.startTimelineGridAnimation();
  updateTimelineImageParameter(slug);


};

const updateTimelineImageParameter = (slug) => {
  const newUrl = new URL(window.location.href);
  if (slug) {
    newUrl.searchParams.set('image', slug);
  } else {
    newUrl.searchParams.delete('image');
  }
  window.history.replaceState({}, '', newUrl);
}

